export const CancellationPath = '/cancellation';

export const getCancellationTitle = (): string => 'Cancellation'; // TODO translate ?
